var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isRecalculating)?_c('v-btn',{attrs:{"rounded":"","min-width":60}},[_c('v-icon',{staticClass:"mr-1",attrs:{"small":""}},[_vm._v("fas fa-spinner fa-spin")])],1):_c('v-btn',{attrs:{"rounded":""}},[_vm._v(_vm._s(_vm.score))])
}
var staticRenderFns = []

export { render, staticRenderFns }